import makeStyles from '@mui/styles/makeStyles';
import {history} from "common/history";
import {color, radius, type} from "common/tokens";
import Card from "components/redesign/Card";
import CtaButton from "components/redesign/CtaButton";
import React from "react";

const useStyles = makeStyles({
  page: {
    background: color.SURFACE,
    minHeight: '100%',
    padding: '48px 32px',
    boxSizing: 'border-box',
  },
  card: {
    width: '100%',
    maxWidth: 560,
    margin: '0 auto',
    padding: 32,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 20,
  },
  title: {
    ...type.panelTitle,
    color: color.TEXT,
    margin: 0,
    textAlign: 'center',
  },
  body: {
    ...type.body,
    color: color.TEXT_MUTED,
    margin: 0,
    textAlign: 'center',
  },
  details: {
    width: '100%',
    background: color.SURFACE_MUTED,
    borderRadius: radius.CARD,
    padding: 20,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  detail: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    minWidth: 0,
  },
  detailLabel: {
    ...type.label,
    color: color.TEXT_MUTED,
  },
  detailValue: {
    ...type.body,
    color: color.TEXT,
    wordBreak: 'break-word',
  },
  link: {
    ...type.body,
    color: color.TERTIARY,
    wordBreak: 'break-all',
  },
});

const MESSAGES = {
  early: {
    title: "You're a bit early",
    body: 'The event link will be active 10 minutes before the event start time. To make changes to the event, please update the event directly on your Mentor To Go calendar.',
  },
  late: {
    title: 'Oops!',
    body: 'The link has expired. To make changes to the event, please update the event directly on your Mentor To Go calendar.',
  },
  busy: {
    title: 'Lines busy',
  },
  failed: {
    title: "Couldn't join the call",
  },
  invalid: {
    title: 'Oops!',
    body: "Looks like you don't have access to this link or the event has been removed. Please check your calendar for the correct link for the event.",
  },
};

export const VideoFrameInvalidMessage = ({type: kind, title = "", time = "", session = "", link = "", body }) => {
  const classes = useStyles();
  const message = MESSAGES[kind] || MESSAGES.invalid;

  const detail = (label, value) => (
    <div className={classes.detail}>
      <span className={classes.detailLabel}>{label}</span>
      <span className={classes.detailValue}>{value}</span>
    </div>
  );

  return (
    <div className={classes.page}>
      <Card bordered className={classes.card}>
        <h2 className={classes.title}>{message.title}</h2>
        <p className={classes.body}>{body || message.body}</p>

        {(kind === 'early' || kind === 'late') && (
          <div className={classes.details}>
            {detail('Event title', title)}
            {detail('Date & time', time)}
            {detail('Session chosen', session || 'No session selected')}
            <div className={classes.detail}>
              <span className={classes.detailLabel}>{'Mentoring call link'}</span>
              <a className={classes.link} href={link} target={'_blank'} rel={'noreferrer'}>{link}</a>
            </div>
          </div>
        )}

        {kind === 'busy' || kind === 'failed' ? (
          <CtaButton
            size={'large'}
            variant={'primary'}
            label={'Try again'}
            onClick={() => window.location.reload()}
          />
        ) : (
          <CtaButton
            size={'large'}
            variant={'primary'}
            label={'Go to calendar'}
            onClick={() => history.push('/mentorship')}
          />
        )}
      </Card>
    </div>
  );
};
